module.exports = __webpack_public_path__ + "static/media/Hungary.39f5a7b4.png";